import { action } from 'mobx';
import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore, SelectColumn } from './agt.analytics.store';

export interface IAgtLeadNowKwkModel {
	vtnrId: number;
	bm: number;
	kwkStatus: string;
}

export class AgtLeadNowKwkModel implements IAgtLeadNowKwkModel {
	vtnrId: number;
	bm: number;
	kwkStatus: string;

	// Legacy compatibility - alias property used by UI store joins on agency id.
	agtId: number;

	constructor(data: any) {
		this.vtnrId = data.aid || 0;
		this.bm = data.bm ? parseInt(data.bm) : 0;
		this.kwkStatus = data.kwk_status || '';
		this.agtId = this.vtnrId;
	}

	get isActive() {
		return this.kwkStatus === 'ACTIVE';
	}
}

export class AgtLeadNowKwkStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'agentur_leadnowkwk',
			defaultColumns: [
				{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, alias: 'aid' },
				{ column: 'bm', aggregateFunction: AggregateFunction.NONE },
				{ column: 'kwk_status', aggregateFunction: AggregateFunction.NONE },
			],
		});
		this.queryName = '?leadNowKwk';
	}

	async getDistinctBMs(): Promise<number[]> {
		const selectColumns: SelectColumn[] = [
			{ column: 'bm', aggregateFunction: AggregateFunction.NONE, distinct: true },
		];
		const results = await this.query(selectColumns);
		return results.map((data) => parseInt(data.bm)).sort((a, b) => a - b);
	}

	@action
	async findByBm(bm: number): Promise<AgtLeadNowKwkModel[]> {
		const results = await this.queryWithWhere(`bm = ${bm}`);
		return results.map((data) => new AgtLeadNowKwkModel(data));
	}

	@action
	async findLatest(): Promise<AgtLeadNowKwkModel[]> {
		const bms = await this.getDistinctBMs();
		if (bms.length === 0) {
			return [];
		}
		return this.findByBm(bms[bms.length - 1]);
	}
}
